import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id F055DA49-5992-4DDC-8C71-E5D331520DEA
 * name lightning-bolt-circle
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightning-bolt-circle.svg
 * tags
 * - Home Automation 
 * - Weather 
 */
export const LightningBoltCircleIcon = createSvgIcon(<><path d="M11.5,20L16.36,10.27H13V4L8,13.73H11.5V20M12,2C14.75,2 17.1,3 19.05,4.95C21,6.9 22,9.25 22,12C22,14.75 21,17.1 19.05,19.05C17.1,21 14.75,22 12,22C9.25,22 6.9,21 4.95,19.05C3,17.1 2,14.75 2,12C2,9.25 3,6.9 4.95,4.95C6.9,3 9.25,2 12,2Z" /></>, 'LightningBoltCircleIcon');
export default LightningBoltCircleIcon